/* eslint-disable no-nested-ternary */
import { Button } from '@dropbox/dig-components/buttons';
import { Banner } from '@dropbox/dig-components/banner';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useBundleProps } from 'signer-app/bundle-props';
import { useSignerContext } from './signer-experience';

const messages = defineMessages({
  genericError: {
    id: '3ddebe9c33255c09162b5085a01047eabe0ebbb0cabe8e8c58cc75e612c6a985',
    defaultMessage:
      'Something went wrong while saving your changes. Your changes are still available on this page.',
    description:
      'Displayed when a server error occurs during signing experience',
  },
  authenticationError: {
    id: 'd6f93a64fb602e41bd5c868271c3f7ca5887cfe2ef60efe0a28c7b83899007cd',
    defaultMessage:
      'Your signing session has expired. Close this page and reopen the original signing link from your email.',
    description:
      'Displayed when the signing session expires during the signing experience',
  },
  smsAuthenticationError: {
    id: 'c122696b4c999341ee65fc01e0d78eda5dc261abfe327f9d109927af8d9e72bf',
    defaultMessage:
      'Your signing session has expired. Close this page and reopen the original signing link from your text message.',
    description:
      'Displayed when the signing session expires during the signing experience for an SMS signer',
  },
  embeddedAuthenticationError: {
    id: '7ee7626b4383be1ad0bea3078006411e4aa261df3ee4b8c8ac3c99827529afc5',
    defaultMessage:
      'Your signing session has expired. Close this signing window and restart signing from the site where it was opened.',
    description:
      'Displayed when the signing session expires during embedded signing',
  },
});

export const ServerErrorBanner = () => {
  const { backendError, isComingFromSmsDelivery, saveDraft } =
    useSignerContext();
  const { embeddedData } = useBundleProps();

  if (!backendError) {
    return null;
  }

  const isAuthenticationError = backendError === 'authentication-error';
  const isEmbeddedAuthenticationError =
    isAuthenticationError && embeddedData?.isEmbeddedSigning === true;
  const authenticationMessage = isComingFromSmsDelivery
    ? messages.smsAuthenticationError
    : messages.authenticationError;

  return (
    <Banner type="warning">
      <Banner.Message>
        {isEmbeddedAuthenticationError ? (
          <FormattedMessage {...messages.embeddedAuthenticationError} />
        ) : isAuthenticationError ? (
          <FormattedMessage {...authenticationMessage} />
        ) : (
          <FormattedMessage {...messages.genericError} />
        )}
      </Banner.Message>
      {!isAuthenticationError && (
        <Banner.Actions>
          <Button variant="transparent" onClick={saveDraft}>
            <FormattedMessage
              id="5d9e0307247cc3305f86bcfca8d6871d3ede84e9416a43d731903266e96d0457"
              defaultMessage="Try again"
              description="Button to retry saving signer changes"
            />
          </Button>
        </Banner.Actions>
      )}
    </Banner>
  );
};
